import React from 'react';
import { Box, Loader } from '@wix/design-system';

export interface CenteredLoaderProps {
  dataHook?: string;
}

export function CenteredLoader({ dataHook }: CenteredLoaderProps) {
  return (
    <Box height="100%" verticalAlign="middle" align="center">
      <Loader size="medium" dataHook={dataHook} />
    </Box>
  );
}
